import { assertTypeMatch } from "@@/utilities/type-helpers";
import type { IsEqual } from "type-fest";
import type { MessageCreatedSocketEvent } from "./message-created.socket-event";
import type {
    MessageSocketEventNamespace,
    MessageSocketEventTypeName,
} from "./message-socket-event.namespace-and-types";
import {
    messageSocketEventNamespace,
    messageSocketEventTypeNames,
} from "./message-socket-event.namespace-and-types";
import type { MessageUpdatedSocketEvent } from "./message-updated.socket-event";

type MessageSocketEvent = MessageCreatedSocketEvent | MessageUpdatedSocketEvent;
type MessageSocketEventType = MessageSocketEvent["type"];

// Make sure our MessageSocketEventType is covering
// all the possible event types defined in MessageSocketEventTypeName
assertTypeMatch<
    IsEqual<
        MessageSocketEventType,
        `${MessageSocketEventNamespace}:${MessageSocketEventTypeName}`
    >
>();

const messageSocketEventTypes = messageSocketEventTypeNames.map(
    name => `${messageSocketEventNamespace}:${name}`,
) as MessageSocketEventType[];

export { messageSocketEventTypes };
export type { MessageSocketEvent, MessageSocketEventType };
